export default {
    name: 'Lock4',
    dimensions: { width: 24, height: 24 },
    content: `
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.5 14C8.5 13.4477 8.94772 13 9.5 13H14.5C15.0523 13 15.5 13.4477 15.5 14C15.5 14.5523 15.0523 15 14.5 15H13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V15H9.5C8.94772 15 8.5 14.5523 8.5 14Z" fill="currentColor"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1C9.23858 1 7 3.23858 7 6V8H6C4.89543 8 4 8.89543 4 10V20C4 21.1046 4.89543 22 6 22H18C19.1046 22 20 21.1046 20 20V10C20 8.89543 19.1046 8 18 8H17V6C17 3.23858 14.7614 1 12 1ZM15 8V6C15 4.34315 13.6569 3 12 3C10.3431 3 9 4.34315 9 6V8H15ZM6 10V20H18V10H6Z" fill="currentColor"/>
    `
};
